(function($, window){
    $.fn.ClipIt = function(options) {
    var settings = $.extend({
        contentSelector: '[data-clipit-content]',
        noticeSelector: '[data-clipit-notice]',
        class: 'clipped'
    }, options);

    function showNotice($notice) {
        $notice.addClass(settings.class);
    }

    function hideNotice($notice) {
        $notice.removeClass(settings.class);
    }

      return this.each(function(){
        $(this).on('click', function(e) {
            var content = this.querySelector(settings.contentSelector);
            var $notice = $(this).find(settings.noticeSelector);

            if(content) {
                /* Select the text field */
                content.select();
                content.setSelectionRange(0, 99999); /*For mobile devices*/

                console.log(content.value);
                /* Copy the text inside the text field */
                document.execCommand("copy");

                showNotice($notice);

                window.setTimeout(function(){
                    hideNotice($notice);
                }, 50);

            } else {
                console.warning('No content found from ClipIt');
            }
        }.bind(this));
      });
    }
  })(jQuery, window);